<div class="user-groups-summary">
    <div *ngIf="!selectedUserGroup" class="arm-summary">0 Items selected</div>
    <div *ngIf="selectedUserGroup" class="arm-summary">
        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Name:</span>
            <span [title]="selectedUserGroup.name" class="arm-summary-value" fxFlex>{{selectedUserGroup.name}}</span>
        </div>
        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Description:</span>
            <span [title]="selectedUserGroup.description" class="arm-summary-value"
                  fxFlex>{{selectedUserGroup.description}}</span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Dialable:</span>
            <span [title]="selectedUserGroup.associatedDialable" class="arm-summary-value"
                  fxFlex>{{selectedUserGroup.associatedDialable}}</span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Conditions:</span>
        </div>

        <li *ngFor="let condition of selectedUserGroup.conditions; let i = index" class="group-details-condition">
            <div class="group-condition-key">
                <span class="group-condition-attribute" [title]="condition.dicAttrName">{{(i + 1)}}. {{condition.dicAttrName}}</span>
                <span class="group-condition-operator"> {{condition.operator}}</span>
            </div>
            <div class="group-condition-value-container">
                    <span *ngFor="let value of condition.values"
                          [title]="value"
                          class="group-condition-value"> {{value}}</span>
            </div>
        </li>

        <divider [title]="'Policy studio'"></divider>

        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Used in policy studio:</span>
            <span [title]="selectedUserGroup.policyStudioInfo" class="arm-summary-value"
                  fxFlex>{{selectedUserGroup.policyStudioInfo}}</span>
        </div>

        <divider [title]="'Routing rule'"></divider>

        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Used in routing rules:</span>
            <span [title]="selectedUserGroup.rules" *ngIf="selectedUserGroup.rules && selectedUserGroup.rules === 'None'"
                  class="arm-summary-value" fxFlex>{{selectedUserGroup.rules}}</span>
        </div>

        <div *ngIf="selectedUserGroup.rules && selectedUserGroup.rules !== 'None'" class="group-details-tree">
            <info-tree [keyValueMode]=false [json]="selectedUserGroup.rules"></info-tree>
        </div>
    </div>
</div>
